(() => {
  const dialog = document.querySelector('[data-ofk-replica-commerce]');
  if (!(dialog instanceof HTMLDialogElement)) return;
  const key = dialog.dataset.ofkReplicaCommerce;
  const picker = dialog.querySelector('[data-ofk-commerce-variant]');
  const productForm = dialog.querySelector('product-form');
  const variantInput = productForm?.querySelector('[name="id"]');
  if (!picker || !productForm || !variantInput) return;
  const options = [...picker.options];
  let opener;
  dialog.close();

  function selectVariant(option, updateUrl = false) {
    if (!option) return;
    picker.value = option.value;
    variantInput.value = option.value;
    const available = option.dataset.available === 'true';
    const quantity = dialog.querySelector('[name="quantity"]');
    quantity.min = option.dataset.min || '1';
    quantity.step = option.dataset.step || '1';
    if (option.dataset.max) quantity.max = option.dataset.max;
    else quantity.removeAttribute('max');
    quantity.value = quantity.min;
    productForm.toggleSubmitButton?.(!available, available ? window.variantStrings.addToCart : window.variantStrings.soldOut);
    dialog.querySelector('[data-ofk-commerce-price]').textContent = option.dataset.price;
    for (const radio of document.querySelectorAll('[data-ofk-replica-size]')) {
      if (radio.dataset.ofkProduct !== key) continue;
      const match = options.find(item => item.dataset.width === radio.dataset.ofkSize);
      radio.disabled = !match || match.dataset.available !== 'true';
      radio.checked = radio.dataset.ofkSize === option.dataset.width;
    }
    for (const slot of document.querySelectorAll('[data-ofk-replica-price]')) {
      if (slot.dataset.ofkProduct !== key) continue;
      const match = slot.dataset.ofkSize ? options.find(item => item.dataset.width === slot.dataset.ofkSize) : option;
      if (match) slot.textContent = match.dataset.price;
    }
    for (const trigger of document.querySelectorAll('[data-ofk-replica-buy]')) {
      if (trigger.dataset.ofkProduct !== key) continue;
      trigger.dataset.ofkSize = option.dataset.width;
      trigger.setAttribute('aria-disabled', String(!available));
    }
    if (updateUrl) {
      const url = new URL(location.href);
      url.searchParams.set('variant', option.value);
      url.searchParams.set('size', option.dataset.width);
      history.replaceState(null, '', url);
    }
  }

  const params = new URLSearchParams(location.search);
  selectVariant(options.find(option => option.value === params.get('variant'))
    || options.find(option => option.dataset.width === params.get('size'))
    || options.find(option => option.value === dialog.dataset.selectedVariant) || options[0]);
  picker.addEventListener('change', () => selectVariant(picker.selectedOptions[0], true));
  document.addEventListener('ofk:replica-size-change', event => {
    if (event.detail?.product === key) selectVariant(options.find(option => option.dataset.width === String(event.detail.size)), true);
  });
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-ofk-replica-buy]');
    if (!trigger || trigger.dataset.ofkProduct !== key || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    selectVariant(options.find(option => option.dataset.width === trigger.dataset.ofkSize));
    opener = trigger;
    productForm.handleErrorMessage?.();
    dialog.showModal();
    picker.focus();
  });
  dialog.querySelector('[data-ofk-commerce-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => opener?.focus());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  // Native Shopify owns requests, cart rendering, standard events and checkout.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
      if (event.source === 'product-form' && options.some(option => option.value === String(event.productVariantId))) {
        dialog.close();
        document.querySelector('cart-drawer')?.setActiveElement?.(opener);
      }
    });
  }
})();
